import { Box, SxProps, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"
import { getCategoryIcon, getFeatureName } from "utils/feature"
import { getIcon } from "utils/icon"

interface ISubCategorySidebarProp {
  mainCategory: any
  SubCategoryComponent: React.ReactNode
  sx?: SxProps
}

export const SubCategorySidebar: React.FC<ISubCategorySidebarProp> = ({
  mainCategory,
  SubCategoryComponent,
  sx = {},
  ...props
}) => {
  const { t } = useTranslation()

  const theme = useTheme()
  const { styleOverrides = {} } = theme.components?.[`SubCategorySidebar`] || {}
  const {
    root,
    mainCategoryWrapper,
    icon,
    mainCategoryLabel,
    subCategoryWrapper,
  } = styleOverrides

  const mainCategoryIcon = getIcon(getCategoryIcon(mainCategory))

  return (
    <Box sx={deepmerge(root, sx)} {...props}>
      <Box sx={mainCategoryWrapper}>
        <Box sx={icon}>{mainCategoryIcon}</Box>
        <Typography variant="h6" sx={mainCategoryLabel}>
          {t(getFeatureName(mainCategory))}
        </Typography>
      </Box>
      <Box sx={subCategoryWrapper}>{SubCategoryComponent}</Box>
    </Box>
  )
}
